import { render, staticRenderFns } from "./simpleTable.vue?vue&type=template&id=5a78c5d8&"
import script from "./simpleTable.vue?vue&type=script&lang=js&"
export * from "./simpleTable.vue?vue&type=script&lang=js&"
import style0 from "./simpleTable.vue?vue&type=style&index=0&id=5a78c5d8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports